<script>
    export default {
        props: {
            defaultMarkerIcons: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            localMarkerIcon(marker) {
                if (this.defaultMarkerIcons) {
                    return {
                        url: '/img/map/neutral.png',
                        scaledSize: {
                            width: 51,
                            height: 59,
                        },
                    };
                }

                if (! marker.is_signed && marker.delivery_project_id) {
                    return {
                        url: '/img/map/delivery/unsigned-delivery.png',
                        scaledSize: {
                            width: 24,
                            height: 24,
                        },
                    };
                }

                let iconFileName = marker.finished_statuses.length ?
                    marker.finished_statuses.join('-') : 'none';

                let scaledSize = {
                    width: (102 * 0.7), // 102 original size
                    height: (53 * 0.7), // 53 original size
                };

                if (marker.finished_statuses.includes('activated')) {
                    iconFileName = 'activated';
                    scaledSize = {
                        width: (51 * 0.7), // 51 original size
                        height: (59 * 0.7), // 59 original size
                    };
                }

                return {
                    url: `/img/map/field/delivery/${iconFileName}.png`,
                    scaledSize: scaledSize,
                };
            },
        },
    };
</script>
